// extracted by mini-css-extract-plugin
module.exports = {"root":"root-12ySP","type_review":"type_review-3jkRu","orderCode":"orderCode-X0EYR"};